// store/slices/contactSlice.js

import { createSlice } from '@reduxjs/toolkit';

// Sample hardcoded data
const initialState = {
  name: 'John Doe',
  phone: '08012345678',
  deliveryMethod: 'pick-up', // 'pick-up' or 'delivery'
  address: '', // Used for delivery only
};

const contactSlice = createSlice({
  name: 'contact',
  initialState,
  reducers: {
    setContactInfo: (state, action) => {
      state.name = action.payload.name;
      state.phone = action.payload.phone;
    },
    setDeliveryMethod: (state, action) => {
      state.deliveryMethod = action.payload;
    },
    setAddress: (state, action) => {
      state.address = action.payload;
    },
  },
});

export const { setContactInfo, setDeliveryMethod, setAddress } = contactSlice.actions;
export default contactSlice.reducer;
